import React from 'react';
import { valueConverter_2 } from '../../../util-functions/util-funtions';

export default function TOTALROW({data}) {
  return (
      <>
      <div className="promotion_total">
                    <div className="total_inner">
                      <label style={{ fontSize: "1.2em", paddingLeft: "1vw" }}>
                        TOTAL
                  </label>
                      <div className="total_data_section">
                        <div className="total_divider">
                          <div className="total_content">
                            <label className="sku_keys"> Inc GP </label>
                            <label className="sku_val" style={{ paddingLeft: '0.7vw' }} > {valueConverter_2(data.GpTon)} </label>
                          </div>
                          <div className="total_content">
                            <label className="sku_keys"> Baseline </label>
                            <label className="sku_val" >{data.Baseline} </label>
                          </div>
                          <div className="total_content">
                            <label className="sku_keys"> Total Vol </label>
                            <label className="sku_val" style={{ paddingLeft: '0.7vw' }}> {valueConverter_2(data.TotalVolume)} </label>
                          </div>
                          <div className="total_content">
                            <label className="sku_keys"> Total Cost </label>
                            <label className="sku_val"> {valueConverter_2(data.TotalCost)} </label>
                          </div>
                          <div className="total_content">
                            <label className="sku_keys"> Inc vol </label>
                            <label className="sku_val" style={{ paddingLeft: '0.7vw' }}>{valueConverter_2(data.IncVolume)} </label>
                          </div>
                          <div className="total_content">
                            <label className="sku_keys"> ROI(%) </label>
                            <label className="sku_val" style={{ paddingLeft: '0.7vw' }}>{!data.Roi ? 0 : valueConverter_2(data.Roi)}
                              </label>
                          </div>
                        </div>
                        <div className="total_divider">
                          <div className="total_content">
                            <label className="sku_keys"> Incremental Aws </label>
                            <label className="sku_val">{valueConverter_2(data.ActivatedAws)} </label>
                          </div>
                          <div className="total_content">
                            <label className="sku_keys">
                              {" "}
                          Total Inc Act Vol{" "}
                            </label>
                            <label className="sku_val">
                              {valueConverter_2(data.TotalActivatedVolume)}{" "}
                            </label>
                          </div>
                          <div className="total_content">
                            <label className="sku_keys"> Activated Weeks </label>
                            <label className="sku_val">
                              {data.ActivityDuration}{" "}
                            </label>
                          </div>
                          <div className="total_content">
                            <label className="sku_keys"> Post Vol </label>
                            <label className="sku_val" style={{ paddingLeft: '0.7vw' }}>{valueConverter_2(data.PostVolume)} </label>
                          </div>
                          <div className="total_content">
                            <label className="sku_keys"> DNDS Vol </label>
                            <label className="sku_val" style={{ paddingLeft: '0.7vw' }}>{valueConverter_2(data.DndsVolume)} </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

      </>
  );
}
